var exports = {
  "Z": "xfd349460--d3b847--layout",
};

module.exports = exports;
